import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Root = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
  overflow: hidden;
`;

const App = ({ children }) => (
  <>
    <Root id="pageRoot">
        { children }
    </Root>
  </>
)

App.propTypes = {
  children: PropTypes.node.isRequired,
}

export default App;
